import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "product-manager" }
const _hoisted_2 = {
  key: 0,
  class: "card-list"
}
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-info" }
const _hoisted_6 = { class: "card-img" }
const _hoisted_7 = { class: "card-footer" }
const _hoisted_8 = { class: "pagination-bar" }

import { ref, computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductManager',
  setup(__props) {

const viewMode = ref('card')
const columns = [
  { title: '产品ID', dataIndex: 'id', key: 'id' },
  { title: '产品名称', dataIndex: 'name', key: 'name' },
  { title: '设备类型', dataIndex: 'type', key: 'type' },
  { title: '通讯方式', dataIndex: 'comm', key: 'comm' },
  { title: '数据协议', dataIndex: 'protocol', key: 'protocol' },
  { title: '品类', dataIndex: 'category', key: 'category' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', key: 'action' }
]
const dataSource = [
  {
    id: '001',
    name: '生成器',
    type: '设备',
    comm: '其他',
    protocol: '联犀MQTT协议',
    category: '传感器设备',
    status: '启用',
    createdAt: '2025/5/2 20:03:18'
  }
]
const cardStatus = ref('enabled') // enabled, disabled, disconnected
const cardStatusText = computed(() => {
  if (cardStatus.value === 'enabled') return '启用'
  if (cardStatus.value === 'disabled') return '禁用'
  if (cardStatus.value === 'disconnected') return '断开'
  return ''
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select_option = _resolveComponent("a-select-option")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { class: "search-bar" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "产品名称",
                      labelCol: { flex: '70px' },
                      wrapperCol: { flex: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "请输入产品名称",
                          style: {"width":"100%"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "产品ID",
                      labelCol: { flex: '70px' },
                      wrapperCol: { flex: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "请输入产品ID",
                          style: {"width":"100%"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "设备类型",
                      labelCol: { flex: '70px' },
                      wrapperCol: { flex: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "请选择设备类型",
                          style: {"width":"100%"},
                          allowClear: ""
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "标签",
                      labelCol: { flex: '70px' },
                      wrapperCol: { flex: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          placeholder: "请选择标签",
                          style: {"width":"100%"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, {
              gutter: 8,
              style: {"margin-top":"1px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "网络",
                      labelCol: { flex: '70px' },
                      wrapperCol: { flex: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "请选择网络",
                          style: {"width":"100%"},
                          allowClear: ""
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "数据协议",
                      labelCol: { flex: '70px' },
                      wrapperCol: { flex: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          placeholder: "请选择数据协议",
                          style: {"width":"100%"},
                          allowClear: ""
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { type: "primary" }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode("+ 新增")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "text",
                          class: _normalizeClass({ active: viewMode.value === 'card' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (viewMode.value = 'card'))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-table-cells-large" })
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_a_button, {
                          type: "text",
                          class: _normalizeClass({ active: viewMode.value === 'list' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (viewMode.value = 'list'))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-list" })
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          style: {"margin-right":"8px"}
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("查询")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_button, { style: {"margin-right":"8px"} }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("重置")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (viewMode.value === 'card')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_a_card, { class: "product-card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "card-title" }, "生成器", -1)),
                    _createVNode(_component_a_button, {
                      size: "small",
                      class: _normalizeClass({
                'status-btn': true,
                'status-enabled': cardStatus.value === 'enabled',
                'status-disabled': cardStatus.value === 'disabled',
                'status-disconnected': cardStatus.value === 'disconnected',
              })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cardStatusText.value), 1)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", null, "产品编号：001", -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("div", null, "产品品类：传感器设备", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("div", null, "设备类型：设备", -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("div", null, "通讯方式：其他", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("div", null, "创建时间：2025/5/2 20:03:18", -1)),
                      _createElementVNode("div", null, [
                        _cache[7] || (_cache[7] = _createTextVNode("标签：")),
                        _createVNode(_component_a_tag, null, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("无标签")
                          ])),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_image, {
                        width: 80,
                        height: 80,
                        preview: false,
                        src: "https://img.icons8.com/ios/100/000000/image.png"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_button, {
                      type: "default",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("详情")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("管理设备")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("删除")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock(_component_a_table, {
              key: 1,
              columns: columns,
              "data-source": dataSource,
              pagination: false
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.key === 'status')
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "green"
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("启用")
                      ])),
                      _: 1
                    }))
                  : (column.key === 'action')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[17] || (_cache[17] = _createElementVNode("a", {
                          onClick: () => {},
                          style: {"color":"#1677ff","margin-right":"8px"}
                        }, "详情", -1)),
                        _cache[18] || (_cache[18] = _createElementVNode("a", {
                          onClick: () => {},
                          style: {"color":"#1677ff","margin-right":"8px"}
                        }, "管理设备", -1)),
                        _cache[19] || (_cache[19] = _createElementVNode("a", {
                          onClick: () => {},
                          style: {"color":"#ff4d4f"}
                        }, "删除", -1))
                      ], 64))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })),
        _createElementVNode("div", _hoisted_8, [
          _cache[22] || (_cache[22] = _createElementVNode("span", null, "共1条", -1)),
          _createVNode(_component_a_pagination, {
            total: 1,
            pageSize: 12,
            current: 1,
            style: {"margin":"0 16px"}
          }),
          _createVNode(_component_a_select, {
            value: 12,
            style: {"width":"90px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select_option, { value: 12 }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createTextVNode("12条/页")
                ])),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: 24 }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createTextVNode("24条/页")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})